// Alerta corta de stock de un SKU (sin stock, bajo, lento, top), igual en Inventario y en Catálogo.
import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

export type StockAlertKey = 'out' | 'low' | 'slow' | 'top';

const STOCK_ALERT_CLASS: Record<StockAlertKey, string> = {
    out: 'bg-danger-soft text-danger',
    low: 'bg-warning-soft text-warning',
    slow: 'bg-muted text-muted-foreground',
    top: 'bg-success-soft text-success',
};

export interface StockAlertChipProps {
    alert: StockAlertKey;
    /** La explicación completa; con ella el chip muestra el cursor de ayuda. */
    title?: string;
    className?: string;
    /** `li` cuando las alertas van en una lista. */
    as?: 'span' | 'li';
    children: ReactNode;
}

export function StockAlertChip({
    alert,
    title,
    className,
    as: Tag = 'span',
    children,
}: StockAlertChipProps) {
    return (
        <Tag
            title={title}
            className={cn(
                'rounded px-1.5 py-px text-[10px] font-bold',
                title !== undefined && 'cursor-help',
                STOCK_ALERT_CLASS[alert],
                className,
            )}
        >
            {children}
        </Tag>
    );
}
